/* eslint-disable no-nested-ternary */
import { useWindowSize } from '@brands/hooks';
import { useAppDispatch, useAppSelector } from '@brands/hooks/useReduxHook';
import { selectAuth } from '@brands/store/selectors/auth';
import { setIsAdminLoginNewDesign } from '@brands/store/slices/isAdminNewDesignSlice';
import cn from 'classnames';
import React, { useEffect, useState } from 'react';
import { useSearchParams } from 'react-router-dom';

import Container from '../../../Components/Container/Container';
import DashboardHeader from '../Components/DashboardHeader/DashboardHeader';
import Appointments from './Sections/Appointments/Appointments';
import History from './Sections/History/History';
import Schedule from './Sections/Schedule/Schedule';
import styles from './styles.module.scss';

const titles = ['Appointments', 'History', 'Schedule / Availability'];

const ProviderDashboard = (): JSX.Element => {
  const dispatch = useAppDispatch();
  const screenSize = useWindowSize();
  const { userInfo } = useAppSelector(selectAuth);

  useEffect(() => {
    dispatch(setIsAdminLoginNewDesign({ userInfo }));
  }, []);

  return (
    <Container
      patientDashboard
      childClassName={styles.dashboard}
      containerStyle={{
        justifyContent: screenSize.width >= 1289 ? 'center' : 'start',
        overflowY: screenSize.width >= 1289 ? 'hidden' : 'scroll',
      }}
    >
      <div
        className={cn(styles.containerPf, styles.providerDashboardBody)}
        style={{ display: 'flex', flexDirection: 'column' }}
      >
        <Appointments />
      </div>
      <form
        className={styles.form}
        style={{ display: 'none' }}
        id="icoreForm"
        target="_blank"
        action={`${process.env.REACT_APP_ICORE_DOMAIN}/api/v1/practice.php`}
        method="POST"
      >
        <input type="text" id="icoreFormData" name="data" readOnly />
        <input type="submit" />
      </form>
    </Container>
  );
};

export default ProviderDashboard;
